/**
 * Theme configuration for the admin dashboard.
 *
 * Colors are defined as RGB values (without rgb() wrapper) to be used
 * with CSS custom properties: rgb(var(--color-primary) / <alpha-value>)
 *
 * This allows dynamic theme switching and org-level theming in the future.
 */

export const themes = {
  default: {
    // Primary brand colors (indigo)
    primary: '79 70 229',        // indigo-600
    primaryHover: '67 56 202',   // indigo-700
    secondary: '107 114 128',    // gray-500
    accent: '14 165 233',        // sky-500

    // Semantic colors
    danger: '220 38 38',         // red-600
    success: '22 163 74',        // green-600
    warning: '245 158 11',       // amber-500
    info: '59 130 246',          // blue-500

    // Surface colors
    surface: '255 255 255',      // white
    surfaceAlt: '249 250 251',   // gray-50

    // Sidebar colors (dark)
    sidebar: '17 24 39',         // gray-900
    sidebarHover: '31 41 55',    // gray-800
    sidebarText: '209 213 219',  // gray-300

    // Text colors
    text: '17 24 39',            // gray-900
    textMuted: '107 114 128',    // gray-500

    // Border colors
    border: '229 231 235',       // gray-200
  },

  // Alternative theme: Teal
  teal: {
    primary: '20 184 166',       // teal-600
    primaryHover: '13 148 136',  // teal-700
    secondary: '107 114 128',
    accent: '14 165 233',
    danger: '220 38 38',
    success: '22 163 74',
    warning: '245 158 11',
    info: '59 130 246',
    surface: '255 255 255',
    surfaceAlt: '249 250 251',
    sidebar: '17 24 39',
    sidebarHover: '31 41 55',
    sidebarText: '209 213 219',
    text: '17 24 39',
    textMuted: '107 114 128',
    border: '229 231 235',
  },

  // Alternative theme: Orange
  orange: {
    primary: '234 88 12',        // orange-600
    primaryHover: '194 65 12',   // orange-700
    secondary: '107 114 128',
    accent: '14 165 233',
    danger: '220 38 38',
    success: '22 163 74',
    warning: '245 158 11',
    info: '59 130 246',
    surface: '255 255 255',
    surfaceAlt: '249 250 251',
    sidebar: '17 24 39',
    sidebarHover: '31 41 55',
    sidebarText: '209 213 219',
    text: '17 24 39',
    textMuted: '107 114 128',
    border: '229 231 235',
  },
};

export type ThemeName = keyof typeof themes;
export type Theme = typeof themes.default;
